import { cn } from "@/lib/utils";
import { STAGE_LABELS, TYPE_LABELS } from "@/lib/format";
import { useT } from "@/i18n";

// Colores derivados estrictamente de la paleta cerrada.
const STAGE_STYLE = {
    nuevo: "bg-nm-accent-soft text-nm-accent",
    contactado: "bg-nm-accent-soft text-nm-accent",
    seguimiento: "bg-nm-accent text-white",
    presentacion: "bg-nm-accent text-white",
    convertido: "bg-nm-panel text-white",
    descartado: "bg-nm-surface-3 text-nm-muted",
};

export function StageBadge({ stage, className }) {
    return (
        <span
            className={cn(
                "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
                STAGE_STYLE[stage] || "bg-nm-surface-3 text-nm-muted",
                className
            )}
            data-testid={`stage-badge-${stage}`}
        >
            {STAGE_LABELS[stage] || stage}
        </span>
    );
}

export function TypeBadge({ type, className }) {
    return (
        <span
            className={cn(
                "inline-flex items-center rounded-full border border-nm-line px-2.5 py-0.5 text-xs font-medium text-nm-muted",
                className
            )}
            data-testid={`type-badge-${type}`}
        >
            {TYPE_LABELS[type] || type}
        </span>
    );
}

// Temperatura del lead · colores derivados de los tokens de la paleta oscura.
const TEMP_STYLE = {
    caliente: "bg-nm-pink/15 text-nm-pink",
    templado: "bg-nm-warn/15 text-nm-warn",
    frio: "bg-nm-cyan/15 text-nm-cyan",
};
const TEMP_DOT = { caliente: "bg-nm-pink", templado: "bg-nm-warn", frio: "bg-nm-cyan" };

export function TemperatureBadge({ temperature, className }) {
    const { t } = useT();
    if (!temperature) return null;
    return (
        <span
            className={cn("inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
                TEMP_STYLE[temperature] || "bg-nm-surface-3 text-nm-muted", className)}
            data-testid={`temperature-badge-${temperature}`}
        >
            <span className={cn("h-1.5 w-1.5 rounded-full", TEMP_DOT[temperature])} />
            {t(`temp.${temperature}`, temperature)}
        </span>
    );
}
